import { style } from "typestyle"
import { shiny_button_style } from "./Shiny_Buttons"
import { Colours } from "../App/style/Colours"

interface Button_Props {
    text: string,
    type?: "submit" | "reset" | "button",
    button_style?: 'Primary' | 'Secondary' | 'Tertiary' | 'Danger',
    fixed_width?: number,
    background_color?: string,
    form?: string,
    test_id?: string,
    onClick?: () => void,
    disabled?: boolean,
    icon?: JSX.Element,
}


export const Button = ({ text, type, button_style, onClick, disabled, test_id, icon, form, fixed_width, background_color }: Button_Props) => {
    
    const button_styles = [base_style, shiny_button_style]
    
    if (fixed_width) {
        button_styles.push(style({
            width: `${fixed_width}em`,
        }))
    }

    if (background_color) {
        button_styles.push(style({
            backgroundColor: background_color,
        }))
    }

    if (button_style === 'Primary') {
        button_styles.push(main_action)
    } else if (button_style === 'Danger') {
        button_styles.push(danger_action)
    }

    const Icon_Element = icon ? <div className={Icon_Style}>{icon}</div> : null

    return (<button 
        type={type} 
        disabled={disabled} 
        onClick={onClick} 
        className={button_styles.join(' ')} 
        data-testId={test_id}
        form={form}>{Icon_Element} <div className={Text_Style}>{text}</div></button>)
}

const Icon_Style = style({
    margin: 'auto 0.5em',
})

const Text_Style = style({
    margin: 'auto 0',
})

const base_style = style({
    display: 'flex',
    justifyContent: 'center',
    height: '2.3em',
	margin: '0.5em 0',
	border: 'none',
	borderRadius: '0.75em',
	fontSize: '1.15em',
	fontWeight: 'bold',
	backgroundColor: 'black',
	color: 'white',
	cursor: 'pointer',
    $nest: {
        '&:disabled': { backgroundImage: 'linear-gradient(#d0d7dd 0%, #979a9c 100%)', },
    }
})

const main_action = style({
	backgroundImage: 'linear-gradient(#ff4e8c 0%, #ad2d58 100%)',
})

const danger_action = style({
	backgroundImage: 'linear-gradient(#372a2a 0%, #050404 100%)',
})

// button.smaller > span {
// 	font-size: 0.9em;
// }

// button.mini_text {
// 	height: auto;
// 	padding: 0.3em;
// }

// button.inline {
// 	float: right;
// }

// button.tiny {
// 	font-size: 0.7em;
// }

// button.mini_text span {
// 	font-size: 0.75em;
// }

// button.icon_button {
// 	display: flex;
// 	padding: 0 0.2em;
// }

// button.icon_button > * {
// 	margin: auto 0.3em;
// }

// button.icon_button > svg {
// 	height: 2rem;
// 	width: 3rem;
// }
// button.icon_button > div {
// 	font-size: 1rem;
// }

export const input_button_attached_style = style({
	fontSize: '1.2em',
	borderRadius: '0.5em 0 0 0.5em',
	maxWidth: '10em',
	border: '0.18em solid black',
    borderRight: '1px solid black',
    marginRight: '0',
    height: '2.3em',
})

export const button_input_attach_style = style({
	height: '2.3em',
	margin: 'auto 0',
	minWidth: '2em',
    backgroundColor: Colours.primary_highlight,
    color: 'white', 
    fontSize: '1.2em',
    borderRadius: '0 0.5em 0.5em 0',
    position: 'relative',
	display: 'inline-block',
	padding: '0 0.5em',
	letterSpacing: '1px',
	textShadow: '0 1px 2px rgba(0, 0, 0, 0.8), 0 -1px 2px rgba(0, 0, 0, 0.2)',
    border: '0.18em solid black',
    borderLeft: '1px solid black',
	boxShadow:
		`0 1px 0 rgba(255, 255, 255, 0.25),
		0 1px 0 rgba(255, 255, 255, 0.25) inset,
		0 0 0 rgba(0, 0, 0, 0.5) inset,
		0 1.10em 0 rgba(255, 255, 255, 0.25) inset,
		0 -1.10em 1.25em rgba(0, 0, 0, 0.32) inset,
		0 1.10rem 1.25em rgba(255, 255, 255, 0.05) inset,
		0 1.10em 6px rgba(255, 255, 255, .1) inset`,

	transition: 'all 150ms linear 0s',

	fontWeight: '600',
	textAlign: 'center',
	textDecoration: 'none',
})

